/**
 * Copyright (c) 2020 Yusaku Nishiwaki
 * Released under the Apache-2.0 license
 * LICENSE: http://www.apache.org/licenses/LICENSE-2.0
 */

const ArgumentType = require("../../extension-support/argument-type");
const BlockType = require("../../extension-support/block-type");
const log = require("../../util/log");
const Cast = require("../../util/cast");
const formatMessage = require("format-message");
const CocoroServo = require("./CocoroServo");

// eslint-disable-next-line max-len
// ブロックの中に表示されるsvg を base64 にして登録
const blockIconURI =
    "data:image/svg+xml;base64,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";
// Scratch画面左のブロックmenu に表示されるsvg を base64にして登録
const menuIconURI =
    "data:image/svg+xml;base64,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";

const AvailableLocales = ["en", "ja", "ja-Hira"];

const Message = {
    categoryName: {
        ja: "ココロキット＋",
        "ja-Hira": "ココロキット＋",
        en: "cocorokit+",
    },
    connect: {
        ja: "接続する",
        "ja-Hira": "つなぐ",
        en: "connect",
    },
    connectionState: {
        none: {
            ja: "左のチェックボックスを押してね",
            "ja-Hira": "ひだりのしかくをおしてね",
            en: "please click the left checkbox",
        },
        not_found: {
            ja: "接続できませんでした",
            "ja-Hira": "つなげられませんでした",
            en: "could not connect",
        },
        try: {
            ja: "接続中...",
            "ja-Hira": "つないでいます...",
            en: "connecting...",
        },
        connected: {
            ja: "接続しました",
            "ja-Hira": "つなぎました",
            en: "connected",
        },
        disconnecting: {
            ja: "切断中",
            "ja-Hira": "きっています",
            en: "disconnecting...",
        },
        lost: {
            ja: "接続を失いました",
            "ja-Hira": "きえてしまいました",
            en: "lost connection",
        },
    },
    angleServo: {
        ja: "モータ[num]を[degree]度にする",
        "ja-Hira": "モータ[num]を[degree]どにする",
        en: "set motor [num] to [degree] degrees",
    },
    angleServoTime: {
        ja: "モータ[num]を[duration]秒間で[degree]度にする",
        "ja-Hira": "モータ[num]を[duration]びょうかんで[degree]どにする",
        en: "set motor [num] to [degree] degree in [duration] seconds",
    },
    getServoDegree: {
        ja: "モータ[num]を[degree]度に",
        "ja-Hira": "モータ[num]を[degree]どに",
        en: "set motor [num] to [degree] degrees",
    },
    execTwo: {
        ja: "２つ同時：[one]と[two]する",
        "ja-Hira": "２つどうじ：[one]と[two]する",
        en: "２ at the same time: [one] and [two]",
    },
    execThree: {
        ja: "３つ同時：[one]と[two]と[three]する",
        "ja-Hira": "３つどうじ：[one]と[two]と[three]する",
        en: "３ at the same time: [one] , [two] , and [three]",
    },
    execFour: {
        ja: "４つ同時：[one]と[two]と[three]と[four]する",
        "ja-Hira": "４つどうじ：[one]と[two]と[three]と[four]する",
        en: "４ at the same time: [one] , [two] , [three] , and [four]",
    },
    changeLed: {
        ja: "[color] を [ratio] にする",
        "ja-Hira": "[color] を [ratio] にする",
        en: "set [color] to [ratio]",
    },
    inputDataChanged: {
        ja: "[sensor] が [high_low] になったとき",
        "ja-Hira": "[sensor] が [high_low] になったとき",
        en: "when [sensor] is turned [high_low]",
    },
    reset: {
        ja: "リセット",
        "ja-Hira": "リセット",
        en: "reset",
    },
    sensorOne: {
        ja: "センサ1",
        "ja-Hira": "センサ1",
        en: "sensor 1",
    },
    sensorTwo: {
        ja: "センサ2",
        "ja-Hira": "センサ2",
        en: "sensor 2",
    },
    low: {
        ja: "OFF",
        "ja-Hira": "オフ",
        en: "off",
    },
    high: {
        ja: "ON",
        "ja-Hira": "オン",
        en: "on",
    },
    red: {
        ja: "赤",
        "ja-Hira": "あか",
        en: "red",
    },
    green: {
        ja: "緑",
        "ja-Hira": "みどり",
        en: "green",
    },
    blue: {
        ja: "青",
        "ja-Hira": "あお",
        en: "blue",
    },
    lost_alert: {
        ja:
            "接続を失いました。再接続するにはチェックボックスを一度外して、初めから接続をしてください。詳細はヘルプブロックを押して説明ページをご覧ください。",
        "ja-Hira":
            "つなぐことができませんでした。もういちどつなぎたいばあい、チェックボックスをはずして、はじめからやりなおしてください。くわしくはヘルプブロックをおしてかくにんしてください。",
        en:
            "disconnected. release the checkbox of connect block. then re-connect the device.",
    },
    smartphone: {
        ja: "スマートフォン用",
        "ja-Hira": "スマートフォンのため",
        en: "for smartphone",
    },
};

const ConnectionState = {
    NONE: "none",
    NOT_FOUND: "notfound",
    TRY: "connecting",
    CONNECTED: "connected",
    DISCONNECTING: "disconnecting",
    LOST: "lost",
};

const LED_COLOR = {
    RED: "0",
    GREEN: "1",
    BLUE: "2",
};


class cocorokitPlusBlocks {
    constructor(runtime) {
        this._runtime = runtime;
        this._cocoroServo = new CocoroServo();
        this._connectionState = ConnectionState.NONE;
        this._alreadyAlert = false;
        this._clicked = false;
        this._intervalId = window.setInterval(
            this._updateConnectionState,
            200,
            this
        );
    }

    getInfo() {
        return {
            id: "cocorokitservo",
            name: Message.categoryName[this.setLocale()],

            color1: "#8BBBB5", // ブロックのメイン色
            color2: "#78A19C", // ブロックの影の色
            menuIconURI: menuIconURI,
            blockIconURI: blockIconURI,

            blocks: [
                {
                    opcode: "connect",
                    blockType: BlockType.REPORTER,
                    text: Message.connect[this.setLocale()],
                },
                "---",
                {
                    opcode: "angleServo",
                    blockType: BlockType.COMMAND,
                    text: Message.angleServo[this.setLocale()],
                    arguments: {
                        num: {
                            type: ArgumentType.STRING,
                            menu: "motors",
                            defaultValue: 0,
                        },
                        degree: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 90,
                        },
                    },
                },
                {
                    opcode: "angleServoTime",
                    blockType: BlockType.COMMAND,
                    text: Message.angleServoTime[this.setLocale()],
                    arguments: {
                        num: {
                            type: ArgumentType.STRING,
                            menu: "motors",
                            defaultValue: 0,
                        },
                        duration: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0,
                        },
                        degree: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 90,
                        },
                    },
                },
                "---",
                {
                    opcode: "getServoDegree",
                    blockType: BlockType.REPORTER,
                    text: Message.getServoDegree[this.setLocale()],
                    arguments: {
                        num: {
                            type: ArgumentType.STRING,
                            menu: "motors",
                            defaultValue: 0,
                        },
                        degree: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 90,
                        },
                    },
                },
                // exec系の [one]〜[four] は getServoDegree レポーターをはめるための入力。
                // arguments を定義すると type に応じた shadow (text) が生えてテキスト入力欄になり、
                // defaultValue 未指定では "undefined" と表示されるため意図的に定義しない。
                // 根拠: src/engine/runtime.js の ArgumentTypeMap と _convertPlaceholders
                {
                    opcode: "execTwo",
                    blockType: BlockType.COMMAND,
                    text: Message.execTwo[this.setLocale()],
                },
                {
                    opcode: "execThree",
                    blockType: BlockType.COMMAND,
                    text: Message.execThree[this.setLocale()],
                },
                {
                    opcode: "execFour",
                    blockType: BlockType.COMMAND,
                    text: Message.execFour[this.setLocale()],
                },
                "---",
                {
                    opcode: "changeLed",
                    blockType: BlockType.COMMAND,
                    text: Message.changeLed[this.setLocale()],
                    arguments: {
                        color: {
                            type: ArgumentType.STRING,
                            menu: "colors",
                            defaultValue: LED_COLOR.RED,
                        },
                        ratio: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100,
                        },
                    },
                },
                "---",
                {
                    opcode: "inputDataChanged",
                    blockType: BlockType.HAT,
                    text: Message.inputDataChanged[this.setLocale()],
                    arguments: {
                        sensor: {
                            type: ArgumentType.NUMBER,
                            menu: "sensors",
                            defaultValue: 3,
                        },
                        high_low: {
                            type: ArgumentType.NUMBER,
                            menu: "values",
                            defaultValue: 0,
                        },
                    },
                },
                {
                    opcode: "returnDigitalInputOne",
                    blockType: BlockType.REPORTER,
                    text: Message.sensorOne[this.setLocale()],
                },
                {
                    opcode: "returnDigitalInputTwo",
                    blockType: BlockType.REPORTER,
                    text: Message.sensorTwo[this.setLocale()],
                },
                "---",
                {
                    opcode: "reset",
                    blockType: BlockType.COMMAND,
                    text: Message.reset[this.setLocale()],
                },
                "---",
                {
                    opcode: "smartphone",
                    blockType: BlockType.COMMAND,
                    text: Message.smartphone[this.setLocale()],
                },
            ],

            menus: {
                motors: {
                    acceptReporters: true,
                    items: this.MOTOR_MENU,
                },
                sensors: {
                    acceptReporters: true,
                    items: this.SENSOR_MENU,
                },
                values: {
                    acceptReporters: true,
                    items: this.HIGH_LOW_MENU,
                },
                colors: {
                    acceptReporters: true,
                    items: this.COLOR_MENU,
                },
            },
        };
    }

    get MOTOR_MENU() {
        return [
            {
                text: "1",
                value: "0",
            },
            {
                text: "2",
                value: "1",
            },
            {
                text: "3",
                value: "2",
            },
            {
                text: "4",
                value: "3",
            },
        ];
    }

    get SENSOR_MENU() {
        return [
            {
                text: Message.sensorOne[this.setLocale()],
                value: "3",
            },
            {
                text: Message.sensorTwo[this.setLocale()],
                value: "4",
            },
        ];
    }

    get HIGH_LOW_MENU() {
        return [
            {
                text: Message.low[this.setLocale()],
                value: "0",
            },
            {
                text: Message.high[this.setLocale()],
                value: "1",
            },
        ];
    }

    get COLOR_MENU() {
        return [
            {
                text: Message.red[this.setLocale()],
                value: LED_COLOR.RED,
            },
            {
                text: Message.green[this.setLocale()],
                value: LED_COLOR.GREEN,
            },
            {
                text: Message.blue[this.setLocale()],
                value: LED_COLOR.BLUE,
            },
        ];
    }

    _updateConnectionState(that) {
        // player-only pages (play/player.html) have no Blockly workspace: the flyout
        // checkbox polled below only exists in the editor.
        const workspace = Blockly.getMainWorkspace();
        if (!workspace) return;

        var targetBlock = workspace.getBlockById(
            "cocorokitservo_connect"
        );
        if (targetBlock) {
            that._clicked = targetBlock.flyoutCheckbox.clicked;
        }

        // { first action

        if (that._connectionState == ConnectionState.NONE) {
            if (that._clicked) {
                that._cocoroServo.connect("cocorokit+").catch((error) => {
                    log.log(error);
                    that._connectionState = ConnectionState.NOT_FOUND; // finish first act
                });

                that._connectionState = ConnectionState.TRY;
            }
        }

        if (that._connectionState == ConnectionState.TRY) {
            if (that._cocoroServo.isConnected()) {
                that._connectionState = ConnectionState.CONNECTED; // finish first act
            }

            if (that._cocoroServo.isConnectionFailed()) {
                that._connectionState = ConnectionState.LOST;
            }
        }

        if (that._connectionState == ConnectionState.CONNECTED) {
            // Unchecked connect button. second act
            if (!that._clicked) {
                that._connectionState = ConnectionState.DISCONNECTING; // finish second act
            }

            // when konashi lost (e.g. power down, took usb cables.)
            if (!that._cocoroServo.isConnected()) {
                that._connectionState = ConnectionState.LOST; // finish first act
            }
        }

        // first act}

        // { third act

        if (that._connectionState == ConnectionState.NOT_FOUND) {
            if (!that._alreadyAlert) {
                alert(Message.lost_alert[that.setLocale()]);
                that._alreadyAlert = true;
            }

            if (!that._clicked) {
                that._reset();
            }
        }

        if (that._connectionState == ConnectionState.LOST) {
            if (!that._alreadyAlert) {
                alert(Message.lost_alert[that.setLocale()]);
                that._alreadyAlert = true;
            }

            if (!that._clicked) {
                that._reset();
            }
        }

        // チェックボックスが外された
        if (that._connectionState == ConnectionState.DISCONNECTING) {
            that._disconnect();
            that._reset();
        }
        // third act }
    }

    /**
     * when device lost, it calls.
     */
    _reset() {
        this._cocoroServo = new CocoroServo();
        this._alreadyAlert = false;
        this._connectionState = ConnectionState.NONE;
    }

    _disconnect() {
        this._cocoroServo.reset();
        this._cocoroServo.dispose();
    }

    reset() {
        this._cocoroServo.reset();
    }

    connect() {
        if (this._connectionState == ConnectionState.NONE) {
            return Message.connectionState.none[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.NOT_FOUND) {
            return Message.connectionState.not_found[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.TRY) {
            return Message.connectionState.try[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.CONNECTED) {
            return Message.connectionState.connected[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.DISCONNECTING) {
            return Message.connectionState.disconnecting[this.setLocale()];
        }

        if (this._connectionState == ConnectionState.LOST) {
            return Message.connectionState.lost[this.setLocale()];
        }

        return "ERROR";
    }

    _degree2duty(degree) {
        if (degree > 180) degree = 180;
        if (degree < 0) degree = 0;

        let value = 1500;

        if (degree == 90) {
            value = 1500;
        } else if (degree > 90) {
            value = 1500 + ((degree - 90) * (2500 - 1500)) / 90;
        } else {
            value = 1500 - ((90 - degree) * (1500 - 500)) / 90;
        }

        return value;
    }

    angleServo(args) {
        let pin = args.num;
        let duty = this._degree2duty(args.degree, false);

        this._cocoroServo.setHardPwmDuty(pin, duty);
    }

    /**
     * 
     * @param {BlockUtility} util - the block utility
     */
    angleServoTime(args, util) {
        if (util.stackTimerNeedsInit()) {
            const duration = Math.max(0, 1000 * Cast.toNumber(args.duration));
            let pin = args.num;
            let duty = this._degree2duty(args.degree, false);

            this._cocoroServo.setHardPwmDutyTime(pin, duty, duration);

            util.startStackTimer(duration);
            this._runtime.requestRedraw();
            util.yield();
        } else if (!util.stackTimerFinished()) {
            util.yield();
        }
    }

    getServoDegree(args) {
        let duty = this._degree2duty(args.degree, false);
        let value = args.num.toString() + "_" + duty.toString();
        return value;
    }

    execTwo(args) {
        const duties = {
            "0": 30000,
            "1": 30000,
            "2": 30000,
            "3": 30000,
        };

        duties[args.one.split("_")[0]] = parseInt(args.one.split("_")[1], 10);
        duties[args.two.split("_")[0]] = parseInt(args.two.split("_")[1], 10);

        this._cocoroServo.setHardPwmDutyAll(
            duties["0"],
            duties["1"],
            duties["2"],
            duties["3"]
        );
    }

    execThree(args) {
        const duties = {
            "0": 30000,
            "1": 30000,
            "2": 30000,
            "3": 30000,
        };

        duties[args.one.split("_")[0]] = parseInt(args.one.split("_")[1], 10);
        duties[args.two.split("_")[0]] = parseInt(args.two.split("_")[1], 10);
        duties[args.three.split("_")[0]] = parseInt(
            args.three.split("_")[1],
            10
        );

        this._cocoroServo.setHardPwmDutyAll(
            duties["0"],
            duties["1"],
            duties["2"],
            duties["3"]
        );
    }

    execFour(args) {
        const duties = {
            "0": 30000,
            "1": 30000,
            "2": 30000,
            "3": 30000,
        };

        duties[args.one.split("_")[0]] = parseInt(args.one.split("_")[1], 10);
        duties[args.two.split("_")[0]] = parseInt(args.two.split("_")[1], 10);
        duties[args.three.split("_")[0]] = parseInt(
            args.three.split("_")[1],
            10
        );
        duties[args.four.split("_")[0]] = parseInt(args.four.split("_")[1], 10);

        this._cocoroServo.setHardPwmDutyAll(
            duties["0"],
            duties["1"],
            duties["2"],
            duties["3"]
        );
    }

    changeLed(args) {
        switch (args.color) {
            case LED_COLOR.RED:
                this._cocoroServo.pwmLedDrive(0, args.ratio);
                break;
            case LED_COLOR.GREEN:
                this._cocoroServo.pwmLedDrive(1, args.ratio);
                break;
            case LED_COLOR.BLUE:
                this._cocoroServo.pwmLedDrive(2, args.ratio);
                break;
            default:
                log.log("ERROR unknown LED defined.");
                break;
        }
    }

    inputDataChanged(args) {
        var data = this._cocoroServo.getDigitalValue(args.sensor);
        if (data == args.high_low) {
            return true;
        }
        return false;
    }

    returnDigitalInputOne() {
        if (!this._cocoroServo.isConnected()) return;

        return this._cocoroServo.getDigitalValue(3);
    }

    returnDigitalInputTwo() {
        if (!this._cocoroServo.isConnected()) return;

        return this._cocoroServo.getDigitalValue(4);
    }

    /**
     *
     */
    smartphone() {
        this._cocoroServo.connect("cocorokit+").then(() => {
            this._connectionState = ConnectionState.CONNECTED;
        })
        .catch((error) => {
            log.log(error);
            this._connectionState = ConnectionState.LOST;
            alert(Message.lost_alert[this.setLocale()]);
        });
    }

    /**
     * return current locale string
     * @returns {String}
     */
    setLocale() {
        let locale = formatMessage.setup().locale;
        if (AvailableLocales.includes(locale)) {
            return locale;
        } else {
            return "en";
        }
    }
}

module.exports = cocorokitPlusBlocks;
